<template>
  <div class="score_block">
    <div class="left">
      <img class='base_image' src='@/assets/image/pages/information/usages/evaluation_1.png'>
      <p>健全なコミュニティを維持するために、評価機能は非常に重要です。</p>
      <p>具体的には、オペレーターのスキルを可視化してクライアントが求めている人材であるか判断したり、クライアントによる不当に低い価格での発注を防ぐ目的があります。</p>
      <br>
      <p class="marker-underline_label">本サイトでは5段階評価を採用していますが、</p>
      <p class="marker-underline_label">標準的なレベルを3としています。</p>
      <br>
      <p>他社オークションサイトなどでは、普通に取引が完了すれば5をつける風潮がありますが、公平、公正な評価基準を守るために是非ともご協力をお願いいたします。</p>
    </div>
    <div class="right">
      <img class='base_image' src='@/assets/image/pages/information/usages/evaluation_2.png'>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ScoreBlock"
  }
</script>

<style lang="scss" scoped>
  .score_block {
    @include double_columns(40%, 40%);

    @media screen and (max-width: 767px) {
      > .right > .base_image {
        margin: 2rem auto 0 auto;
      }
    }
  }
</style>